import { CsvConfigConsts } from './csv-config-consts';
import { Options } from './csv-options.interface';

export const ConfigDefaults: Options = {
  decimalSeparator: CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR,
  fieldSeparator: CsvConfigConsts.DEFAULT_FIELD_SEPARATOR,
  filename: CsvConfigConsts.DEFAULT_FILENAME,
  headers: CsvConfigConsts.DEFAULT_HEADER,
  quoteStrings: CsvConfigConsts.DEFAULT_QUOTE,
  showLabels: CsvConfigConsts.DEFAULT_SHOW_LABELS,
  showTitle: CsvConfigConsts.DEFAULT_SHOW_TITLE,
  title: CsvConfigConsts.DEFAULT_TITLE,
  useBom: CsvConfigConsts.DEFAULT_USE_BOM,
};
